
function Center() {
    return (
      <div className="footer">
          
        ruadaslucia

        </div>
    );
  }
  
  export default Center;